import React from "react";
// react component for creating beautiful carousel
import Carousel from "react-slick";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import LocationOn from "@material-ui/icons/LocationOn";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";


import carouselStyle from "assets/jss/material-kit-react/views/componentsSections/carouselStyle.jsx";

import arch1 from "assets/img/arch1.jpg";
import arch2 from "assets/img/arch2.jpg";
import arch3 from "assets/img/arch3.jpg";
import arch5 from "assets/img/arch5.jpg";
import arch6 from "assets/img/arch6.jpg";
import arch7 from "assets/img/arch7.jpg";

class SectionCarousel extends React.Component {
  render() {
    const { classes } = this.props;
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,

    };
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={8} className={classes.marginAuto}>
              <Card carousel>
                <Carousel {...settings}>
              <div>
                    <img
                      src={arch1}
                      alt="ARCHI"
                      className="slick-image"
                    />
                   <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Design
                      </h4>
                    </div>
                  </div>
                 <div>
                    <img
                      src={arch2}
                      alt="ARCHI"
                      className="slick-image"
                    />
                    <div>
                   <h4 className={classes.text}>
                      <LocationOn/>The Integrated Building
                      </h4>
                    </div>
                  
                  </div>
                  <div>
                    <img
                      src={arch3}
                      alt="ARCHI"
                      className="slick-image"
                    />
                 <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Punggol Waterway
                      </h4>
                    </div>
                  </div>
                
                  <div>
                    <img
                      src={arch5}
                      alt="ARCHI"
                      className="slick-image"
                    />
                  <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Novartis BiopharmOps 
                      </h4>
                    </div>
                  </div>
                  <div>
                    <img
                      src={arch6}
                      alt="ARCHI"
                      className="slick-image"
                    />
                  <div>
                   <h4 className={classes.text}>
                      <LocationOn/>The Kendall
                      </h4>
                    </div>
                  </div>
                  <div>
                    <img
                      src={arch7}
                      alt="ARCHI"
                      className="slick-image"
                    />
                  <div>
                   <h4 className={classes.text}>
                      <LocationOn/>The Kendall
                      </h4>
                    </div>
                  </div>
                  

                </Carousel>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(carouselStyle)(SectionCarousel);



// WEBPACK FOOTER //
// ./src/views/ArchiPage/Sections/SectionCarousel.jsx